import React, { useState, useEffect } from 'react'
import { Row, Col } from 'reactstrap';
import { TextField } from '@material-ui/core';
import CrearUsuario from '../../../components/buttons/crearUsuario';
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from 'react-loaders'

//Redux
import { connect } from 'react-redux';

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const updatePassword = functionsHttpsCallable('usuarios_actualizarPassword');


const mapStateToProps = state => ({
    usuarioActivo: state
})

let BodyUpdatePass = (props) => {
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [passConf, setPassConf] = useState('');
    const [loading, setLoading] = useState(false);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    useEffect(() => {
    }, [email]);

    const updateUser = async () => {
        setLoading(true)
        const body = {
            password: pass,
            email: email,
            token: userData.token
        }
        const updateUserReq = await updatePassword(body);
        if (updateUserReq.data.status === 'USUARIO_ACTUALIZADO') {
            props.toastSuccess('Contraseña actualizada')
        }
        else {
            props.toastError(`Hubo un error al actualizar la contraseña: ${updateUserReq.data.message}`)
        }
        setLoading(false)
    }

    return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='12' md='12' xs="12">
                        <TextField
                            required
                            key={`key_mail`}
                            id={`input_mail`}
                            fullWidth
                            label='correo'
                            margin="normal"
                            onChange={(e) => { setEmail(e.target.value) }}
                        />
                    </Col>
                </Row>
                <Row className='user-mail-modal'>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            key={`key_pass`}
                            id={`input_pass`}
                            fullWidth
                            type="password"
                            label='Contraseña'
                            margin="normal"
                            onChange={(e) => { setPass(e.target.value) }}
                        />
                    </Col>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            required
                            key={`key_passConf`}
                            id={`input_passconf`}
                            fullWidth
                            type="password"
                            label='Confirmar Contraseña'
                            margin="normal"
                            onChange={(e) => { setPassConf(e.target.value) }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg='12' md='12' xs="12" className='user-create-button'>
                        <CrearUsuario
                            tittle={'Actualizar'}
                            onClick={() => updateUser()}
                            disabled={!(pass === passConf && email.includes('@'))} />
                    </Col>
                </Row>
            </div>
        </div>
    );
}
export default connect(mapStateToProps)(BodyUpdatePass);